export default {
    CA: "dfc82482-8cb2-11de-a173-001372568c9a"
};